import { Database, Model } from '@nozbe/watermelondb';

import { ValidationOperation } from '../../../validation/validator';

export type ProcedureEntityTableName =
    | 'procedures'
    | 'entry_procedures'
    | 'users';

export type PreparedProcedureData = {
    record: Model;
    table: ProcedureEntityTableName;
    operation: ValidationOperation;
};

export const mapRecord = (
    record: Model,
    table: ProcedureEntityTableName,
    operation: ValidationOperation,
): PreparedProcedureData => ({
    record,
    table,
    operation,
});

export const mapRecords = (
    records: Model[],
    table: ProcedureEntityTableName,
    operation: ValidationOperation,
): PreparedProcedureData[] =>
    records.map((record) => mapRecord(record, table, operation));

export const addPreparedDataBatch = async (
    preparedData: PreparedProcedureData[],
    database: Database,
) => {
    await database.batch(...preparedData.map(({ record }) => record));
};
